export default "__VITE_ASSET__007bf1af__"